import * as React from 'react';
import { motion } from 'framer-motion';

// Define prop types
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string; // Allow passing additional Tailwind classes
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  className = ''
}) => {

  // Base styles
  const baseStyle = "inline-block rounded-full font-bold text-center transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 text-sm md:text-base py-3 px-6 md:py-3 md:px-8 leading-none";


  return (
    <motion.button
      type={type}
      className={`${baseStyle} ${className}`}
      onClick={onClick}
      whileHover={{ scale: 1.03 }} // Framer Motion hover effect
      whileTap={{ scale: 0.98 }}   // Framer Motion tap effect
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
    >
      {children}
    </motion.button>
  );
};

export default Button; 